import { createApi } from '@reduxjs/toolkit/query/react';

import { identify as analyticsIdentify, trackEvent } from '../helpers/analytics';
import { identifyUser } from '../helpers/supportChat';
import { authBaseQuery } from './queries';

export const mapOAuthProviderName = (provider) => {
  switch (provider) {
    case 'google_oauth2':
      return 'Google';
    case 'linkedin':
      return 'LinkedIn';
    default:
      return provider;
  }
};

export const setupUserSession = (user) => {
  analyticsIdentify(user);
  identifyUser(user);
  trackEvent('user_logged_in');

  return user;
};

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    signOut: builder.mutation({
      query: () => ({
        url: '/auth/logout',
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useSignOutMutation } = authApi;
